export const FileUtils = {
  setImagePreview: (file: File, elementId: string) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const imgElement = document.getElementById(elementId) as HTMLImageElement;
      if (imgElement) {
        imgElement.src = e.target?.result as string;
      }
    };
    reader.readAsDataURL(file);
  },
};
